export default __webpack_public_path__ + "static/phone-world-btn-1068005f0b66d8319966d5c93cb31058.png";